import { graphql } from '@/gql';
import type { UpdatePaymentSourceMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';

export const updatePaymentSource = async ({ data, cardId, userId }: UpdatePaymentSourceMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      data,
      cardId,
      userId,
    },
    mutation: graphql(`
      mutation UpdatePaymentSource($data: CardInputType!, $cardId: String!, $userId: String!) {
        updatePaymentSource(data: $data, cardId: $cardId, userId: $userId) {
          id
          object
          address_city
          address_country
          address_line1
          address_line1_check
          address_line2
          address_state
          address_zip
          address_zip_check
          brand
          country
          customer
          exp_month
          exp_year
          fingerprint
          funding
          last4
          name
          is_default
          metadata
          email
          phone
          notes
          cvc_check
          distanceFromHomeAddressInMiles
          isDirectExpress
        }
      }
    `),
  });

  const card = util.formatCreditCardInfo(response.data!.updatePaymentSource);

  return card;
};
